import { render, staticRenderFns } from "./LeftLogo.vue?vue&type=template&id=df2e2a14&scoped=true&"
import script from "./LeftLogo.vue?vue&type=script&lang=js&"
export * from "./LeftLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2e2a14",
  null
  
)

export default component.exports